export default __webpack_public_path__ + "static/media/merchant.97184428.svg";